document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.Index_object_real_results_slider').forEach(function (el) {
        new Swiper(el, {
            slidesPerView: 'auto', 
            spaceBetween: 16,
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
        });
    });
});